import { render, staticRenderFns } from "./BankCollapseItem.vue?vue&type=template&id=4278e5fa&"
import script from "./BankCollapseItem.vue?vue&type=script&lang=js&"
export * from "./BankCollapseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports